import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { setLanguage, supportedLanguages, type Language } from '@/i18n';

export function LanguageToggle() {
  const { t, i18n } = useTranslation();

  return (
    <div
      role="group"
      aria-label={t('settings.language')}
      className="inline-flex gap-1 rounded-lg border border-line bg-surface p-1"
    >
      {supportedLanguages.map((language: Language) => (
        <Button
          key={language}
          size="sm"
          variant={i18n.language === language ? 'primary' : 'ghost'}
          aria-pressed={i18n.language === language}
          onClick={() => void setLanguage(language)}
        >
          {language.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
